import { serializeJsonLd } from "./serializeJsonLd";

import type { JSX } from "react";

// // // //

/**
 * JsonLd
 * Renders a JSON-LD payload as a <script type="application/ld+json"> tag.
 *
 * NOTE - next-seo's JSON-LD primitives (`WebPageJsonLd`, `BreadcrumbJsonLd`, ...)
 * render through `next/head`, which is a no-op in the App Router: they emit
 * NOTHING, with no error. Hand-built payloads work in both routers, so every
 * structured-data component in this codebase goes through here.
 *
 * NOTE - render these from the server `page.tsx` rather than the client view.
 * The payloads are pure metadata, and keeping them server-side avoids shipping
 * them in the client bundle (the /citations payload alone is ~140 kB).
 */
export function JsonLd(props: { data: Record<string, unknown> }): JSX.Element {
    const { data } = props;

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: serializeJsonLd(data) }}
        />
    );
}
